import React from "react";
import "./addToCart.component.sass";
import {
	Form,
	Col,
	Row,
	Badge,
	Radio,
	RadioGroup,
	FormControl,
	ControlLabel,
	Toggle,
	FormGroup,
	Button,
	Schema,
} from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
	selectProducts,
	selectSelectedProduct,
} from "../../redux/site/site.selector";
import {
	selectInstallation,
	selectInternalOrExternal,
	selectPrice,
} from "../../redux/cart/cart.selector";
import {
	SetInstallation,
	SetIntarnalOrExternal,
	SetPrice,
} from "../../redux/cart/cart.actions";
import { AddProduct } from "../../redux/users/users.actions";
import { selectProduct } from "../../redux/users/users.selector";
import AddRemoveComponent from "../addRemoveProduct/addRemove.component";
import { calculatePrice, ConvertToPersianNumber } from "../../script";

class AddToCartComponent extends React.Component {
	constructor(props) {
		super(props);
		const formValue = {
			productFor: "inner",
			install: false,
		};
		this.state = {
			formValue: formValue,
		};
	}

	componentDidMount() {
		const { setPrice, product } = this.props;
		setPrice(parseInt(product.inner_car_price));
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		const { setPrice, product } = this.props;
		if (prevProps.product !== product)
			setPrice(parseInt(product.inner_car_price));
	}

	render() {
		const { formValue } = this.state;
		const {
			product,
			getPrice,
			getInstallation,
			getInternalOrExternal,
			addProduct,
			productItem,
			setInternalOrExternal,
			setInstallation,
			setPrice,
			Products,
		} = this.props;
		let SelectProduct = product;
		SelectProduct.install = false;
		SelectProduct.productFor = "inner";
		SelectProduct.Price = product.inner_car_price;

		const HandleSubmit = (value, formValue) => {};
		const HandleChange = (formValue) => {
			this.setState({ formValue });
			if (formValue.install === true) {
				setInstallation(true);
				SelectProduct.install = true;

				if (formValue.productFor === "inner") {
					setInternalOrExternal("inner");
					SelectProduct.productFor = "inner";
					setPrice(SelectProduct.inner_car_price + SelectProduct.install_price);
					SelectProduct.Price =
						SelectProduct.inner_car_price + SelectProduct.install_price;
				} else {
					setInternalOrExternal("outer");
					SelectProduct.productFor = "outer";
					setPrice(SelectProduct.outer_car_price + SelectProduct.install_price);
					SelectProduct.Price =
						SelectProduct.outer_car_price + SelectProduct.install_price;
				}
			} else {
				setInstallation(false);
				SelectProduct.install = false;

				if (formValue.productFor === "inner") {
					setInternalOrExternal("inner");
					SelectProduct.productFor = "inner";
					setPrice(SelectProduct.inner_car_price);
					SelectProduct.Price = SelectProduct.inner_car_price;
				} else {
					setInternalOrExternal("outer");
					SelectProduct.productFor = "outer";
					setPrice(SelectProduct.outer_car_price);
					SelectProduct.Price = SelectProduct.outer_car_price;
				}
			}
		};

		const model = Schema.Model({});
		return (
			<div className="add-to-cart">
				<Form
					model={model}
					formValue={formValue}
					onChange={(formValue) => HandleChange(formValue)}
					onSubmit={(value, formValue) => HandleSubmit(value, formValue)}
				>
					{
						<div>
							{SelectProduct.outer_car_price !== 0 &&
								SelectProduct.type === "vehicle" && (
									<FormGroup>
										<FormControl
											name="productFor"
											accepter={RadioGroup}
											inline
										>
											<Radio value="inner">خودرو های داخلی</Radio>
											<Radio value="outer">خودرو های خارجی</Radio>
										</FormControl>
									</FormGroup>
								)}
							{parseInt(SelectProduct.offer) ? (
								<Row>
									<Col
										xs={12}
										style={{ textAlign: "center" }}
									>
										<span>
											{ConvertToPersianNumber(calculatePrice(SelectProduct))}
										</span>
										<span>
											<small>تومان</small>
										</span>
									</Col>
									<Col xs={12}>
										<h5>
											<strike>
												{ConvertToPersianNumber(getPrice)}{" "}
												<Badge
													content={`% ${ConvertToPersianNumber(
														SelectProduct.offer
													)}`}
												/>
											</strike>
										</h5>
									</Col>
								</Row>
							) : (
								<Row>
									<Col
										xs={24}
										style={{ textAlign: "center" }}
									>
										<span>{ConvertToPersianNumber(getPrice)}</span>
										<span>
											<small> تومان </small>
										</span>
									</Col>
								</Row>
							)}

							{SelectProduct.outer_car_price !== 0 && (
								<div>
									<FormGroup>
										<ControlLabel>
											همراه نصب{" "}
											<FormControl
												accepter={Toggle}
												name="install"
												onChange={(e) => {}}
											/>
										</ControlLabel>
									</FormGroup>
								</div>
							)}
							<br />
						</div>
					}
					{SelectProduct.exist === "1" ? (
						productItem &&
						productItem.find((o) => o.id === SelectProduct.id) ? (
							<AddRemoveComponent
								item={SelectProduct}
								productPage
							/>
						) : (
							<Button
								disabled={!getPrice}
								size="lg"
								onClick={(value) => {
									SelectProduct.productFor = getInternalOrExternal;
									SelectProduct.install = getInstallation;
									addProduct(SelectProduct);
								}}
								className="add-to-cart-btn"
								block
							>
								افزودن به سبد خرید
							</Button>
						)
					) : SelectProduct.exist === "2" ? (
						<div className="notExist">
							<span>بزودی</span>
						</div>
					) : (
						<div className="notExist">
							<span>فروش و نصب در نمایندگی ها</span>
						</div>
					)}
					{formValue.install && product.info ? (
						<p className="product-info">
							{product.info}
							<span class="top"></span>
							<span class="right"></span>
							<span class="bottom"></span>
							<span class="left"></span>
						</p>
					) : (
						""
					)}
				</Form>
			</div>
		);
	}
}
const mapStateToProps = createStructuredSelector({
	product: selectSelectedProduct,
	productItem: selectProduct,
	getPrice: selectPrice,
	getInstallation: selectInstallation,
	getInternalOrExternal: selectInternalOrExternal,
	Products: selectProducts,
});
const mapDispatchToProps = (dispatch) => ({
	addProduct: (product) => dispatch(AddProduct(product)),
	setInternalOrExternal: (value) => dispatch(SetIntarnalOrExternal(value)),
	setInstallation: (value) => dispatch(SetInstallation(value)),
	setPrice: (price) => dispatch(SetPrice(price)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddToCartComponent);
